module.exports = __webpack_public_path__ + "img/project-4.b510a107.png";